import { Modal, Button, Row, Col } from "antd";
import { FormatCurrency } from "../../../../common/format/formatCurrency";
import { FaMoneyBillWave, FaBuilding, FaGlobe, FaCreditCard } from "react-icons/fa";
import "../../utils/versementConfirm.css";

const VersmentConfirm = ({ visible, onClose, onConfirm, data }) => {
  if (!data) return null;

  return (
    <Modal
      title="Confirmer le reversement"
      visible={visible}
      onCancel={onClose}
      footer={[
        <Button key="back" className="versConf-btn-cancel" onClick={onClose}>
          Annuler
        </Button>,
        <Button key="submit" type="primary" className="versConf-btn-confirm" onClick={onConfirm}>
          Confirmer
        </Button>,
      ]}
      className="versConf-modal"
      centered
    >
      <p className="versConf-instruction">
        Vérifiez bien toutes les informations avant de confirmer votre reversement.
      </p>

      <Row gutter={[16, 16]} className="versConf-row">
        <Col span={12} className="versConf-label"><FaBuilding /> Business</Col>
        <Col span={12} className="versConf-value">{data.businessName || "-"}</Col>

        <Col span={12} className="versConf-label"><FaGlobe /> Pays</Col>
        <Col span={12} className="versConf-value">{data.country?.countryName || "-"}</Col>

        <Col span={12} className="versConf-label"><FaCreditCard /> Mode de versement</Col>
        <Col span={12} className="versConf-value">{data.verseMode === "bank" ? "Virement bancaire" : "Mobile Money"}</Col>

        <Col span={12} className="versConf-label"><FaMoneyBillWave /> Compte </Col>
        <Col span={12} className="versConf-value">{data.accountDetails || "-"}</Col>

        <Col span={12} className="versConf-label"> {data.verseMode !== "bank" ? "Methode" : "Iban"}</Col>
        <Col span={12} className="versConf-value">{data.accountName || "-"}</Col>
        
        {data.verseMode !== "bank" && (
          <>
            <Col span={12} className="versConf-label">Montant</Col>
            <Col span={12} className="versConf-value">{FormatCurrency(data.amount, data.country?.currency)}</Col>
            <Col span={12} className="versConf-label">Frais</Col>
            <Col span={12} className="versConf-value">{FormatCurrency(data.frais || 0, data.country?.currency)}</Col>
          </>
        )}

        <Col span={12} className="versConf-label versConf-total">Montant total débité </Col>
        <Col span={12} className="versConf-value versConf-total">{FormatCurrency((data.amount || 0) + (data.verseMode !== "bank" ? data.frais : 0), data.country?.currency)}</Col>
      </Row>
    </Modal>
  );
};

export default VersmentConfirm;